import {IContent} from "../../HubFramework"
import UsersTab from "./Tabs/UsersTab";
import Config from "./Tabs/Config";
import {AppDisplayName, authLevels, defaultAuth, DisableTenantManagement, userTenant} from "./constants";
import IDMSDocumentation from "./Tabs/IDMSDocumentation";
import {UserRoles} from "../../Utils";
import {odxIconSets} from "../../OdxComponents/constants";

/**
 * The content of the module
 * This is mandatory for every module. It contains all the information about the module.
 */
export const moduleContent: IContent = {
    moduleName: "idmsProd",
    title: "IDMS",
    pages: [
        {
            displayName: "User Management",
            contentPage: UsersTab.bind(null, {hubOrIdmsLevel: "IDMS"}),
            minimumRole: UserRoles.reader,
            icon: {
                name: "user-administration",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "Config",
            contentPage: Config,
            minimumRole: UserRoles.reader,
            icon: {
                name: "config",
                iconSet: odxIconSets.core
            },
        },
        {
            displayName: "Documentation",
            contentPage: IDMSDocumentation,
            minimumRole: UserRoles.reader,
            icon: {
                name: "document-settings",
                iconSet: odxIconSets.core
            },
        }
    ],
    defaultPage: "Config",
    creationProps: [
        {
            name: "",
            type: "subProps",
            description: "",
            value: "",
            subProps: {
                value: [
                    {
                        name: AppDisplayName,
                        displayName: "App Display Name",
                        type: "string",
                        description: "Display Name",
                        value: ""
                    },
                    {
                        name: defaultAuth,
                        displayName: "Default Authentication Level",
                        type: "string",
                        description: "Default authentication level, must be in authLevels",
                        value: "admin",
                    },
                    {
                        name: authLevels,
                        displayName: "Authentication Levels",
                        type: "string[]",
                        description: "Authentication levels",
                        value: ["admin", "user", "blocked"]
                    },
                    {
                        name: userTenant,
                        displayName: "User Tenant",
                        type: "select",
                        description: "User Tenant",
                        value: "draegerb2c",
                        options: [ "oktaDev", "oktaTest", "oktaProd", "draegerb2c", "draegerConnect"]
                    },
                    {
                        name: DisableTenantManagement,
                        type: "boolean",
                        displayName: "Disable Tenant Management",
                        description: "Activate this if you want to disable the tenant management",
                        value: false,
                    }
                ]
            }
        }
    ]
};
